// app.js
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials';
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import Heading from '@ckeditor/ckeditor5-heading/src/heading';
import List from '@ckeditor/ckeditor5-list/src/list';
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold';
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic';
import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter';
import Link from '@ckeditor/ckeditor5-link/src/link';
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage';
import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment';

import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize';
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload';
import ImageConfig from '@ckeditor/ckeditor5-image/src/image';
import ImageResizeEditing from '@ckeditor/ckeditor5-image/src/imageresize/imageresizeediting';
import ImageResizeHandles from '@ckeditor/ckeditor5-image/src/imageresize/imageresizehandles';
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed';



import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';
import SourceEditing from '@ckeditor/ckeditor5-source-editing/src/sourceediting';

import Table from '@ckeditor/ckeditor5-table/src/table';
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar';

import SimpleBox from './simplebox/simplebox';

import AccordionPlugin from './public/assets/plugin/AccordionPlugin';

import $ from 'jquery';
// require('select2');              // globally assign select2 fn to $ element
// import 'select2/dist/css/select2.css';   // optional if you have css loader

// import 'chosen-js';

$(() => {
    // $("select.form-control").chosen({ disable_search_threshold: 10 });
    // $('.select2').select2();

    initCKEditor();
});



function initCKEditor() {

    // all id's, starting with, ckEditor
    const selector = '[id^="ckEditor"]';

    $(selector).each(function () {
        if (this.id) {
            const selector = `#${this.id}`;
            initializeCKEditor(selector);
        }
    });

    function initializeCKEditor(selector, config = {}) {

        config = {

            plugins: [
                CKFinder,
                SourceEditing,
                Essentials,
                UploadAdapter,
                Bold,
                Italic,
                Heading,
                Image, LinkImage, ImageStyle, ImageToolbar, ImageUpload, ImageConfig, ImageResize, ImageResizeEditing, ImageResizeHandles,
                Link,
                List,
                Paragraph,
                Alignment,
                Table, TableToolbar,
                SimpleBox,
                MediaEmbed,
                AccordionPlugin,
            ],
            toolbar: {
                items: [
                    'sourceEditing',
                    'ckfinder',
                    'heading',
                    '|',
                    'alignment',
                    'bold',
                    'italic',
                    'link',
                    'bulletedList',
                    'numberedList',
                    '|',
                    // 'uploadImage',
                    'mediaEmbed',
                    'insertTable',
                    '|',
                    'undo',
                    'redo',
                    'simpleBox',
                    'accordion',
                ]
            },
            mediaEmbed: {
                previewsInData: true
            },
            image: {
                toolbar: [
                    'linkImage',
                    '|',
                    'imageTextAlternative',
                    '|',
                    'imageStyle:alignLeft',
                    // 'imageStyle:full',
                    'imageStyle:alignRight',
                    '|',
                    {
                        name: 'imageStyle:pictures',
                        items: ['imageStyle:block', 'imageStyle:side'],
                        defaultItem: 'imageStyle:block'
                    }
                ],
                styles: [
                    'full',
                    'alignLeft',
                    'alignRight'
                ],
                resizeOptions: [
                    {
                        name: 'resizeImage:original',
                        value: null,
                        label: 'Original'
                    },
                    {
                        name: 'resizeImage:25',
                        value: '25',
                        label: '25%'
                    },
                    {
                        name: 'resizeImage:50',
                        value: '50',
                        label: '50%'
                    },
                    {
                        name: 'resizeImage:100',
                        value: '100',
                        label: '100%'
                    }
                ],
            },
            link: {
                defaultProtocol: 'https://',
                decorators: {
                    openInNewTab: {
                        mode: 'manual',
                        label: 'Open in a new tab',
                        attributes: {
                            target: '_blank',
                            rel: 'noopener noreferrer'
                        }
                    }
                }
            }
            , ...config
        }

        ClassicEditor
            .create(document.querySelector(selector), config)
            .then(editor => {
                if (typeof on_dev !== 'undefined' && on_dev) {
                    console.log('Editor was initialized', editor);
                }

                // Expose for playing in the console.
                window.editor = editor;
            })
            .catch(error => {
                console.error(error.stack);
            });
    }
}